import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities = [] }) => {
  const getActivityIcon = (type) => {
    const iconMap = {
      'work-order': 'ClipboardList',
      'inspection': 'Search',
      'quotation': 'FileText',
      'approval': 'CheckCircle',
      'cancellation': 'XCircle',
      'update': 'RefreshCw'
    };
    return iconMap?.[type] || 'Bell';
  };

  const getActivityColor = (type) => {
    const colorMap = {
      'work-order': 'text-primary',
      'inspection': 'text-accent',
      'quotation': 'text-secondary',
      'approval': 'text-success',
      'cancellation': 'text-error',
      'update': 'text-warning'
    };
    return colorMap?.[type] || 'text-muted-foreground';
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Hace un momento';
    if (diffMins < 60) return `Hace ${diffMins} min`;
    if (diffHours < 24) return `Hace ${diffHours}h`;
    if (diffDays < 7) return `Hace ${diffDays}d`;
    return date?.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit' });
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="Activity" size={24} className="text-accent" />
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Actividad Reciente
        </h2>
      </div>
      <div className="space-y-3 md:space-y-4 max-h-96 overflow-y-auto scroll-smooth">
        {activities?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Inbox" size={48} className="text-muted-foreground mx-auto mb-2" />
            <p className="text-sm caption text-muted-foreground">
              No hay actividad reciente
            </p>
          </div>
        ) : (
          activities?.map((activity) => (
            <div
              key={activity?.id}
              className="flex items-start gap-3 p-3 rounded-lg hover:bg-muted/50 transition-smooth"
            >
              <div className={`p-2 rounded-lg bg-muted/50 flex-shrink-0`}>
                <Icon 
                  name={getActivityIcon(activity?.type)} 
                  size={16} 
                  className={getActivityColor(activity?.type)} 
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-body font-medium text-foreground mb-1">
                  {activity?.title}
                </p>
                <p className="text-xs caption text-muted-foreground mb-1">
                  {activity?.description}
                </p>
                <div className="flex items-center gap-2 text-xs caption text-muted-foreground">
                  <Icon name="Clock" size={12} />
                  <span>{formatTime(activity?.timestamp)}</span>
                  {activity?.user && (
                    <>
                      <span>•</span>
                      <span>{activity?.user}</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;